// 捷克语
export default {
    login_module: {
        Login: 'Přihlásit se',
        Register: 'Registrace',
        noAccount: 'Ještě nemáte účet?',
        hasAccount: 'Máte již účet?',
        IAgree: 'souhlasím s',
        rememberMe: 'Zapamatuj si mě',
        lostPassword: 'Ztracené heslo',
        send: 'Poslat',
        userName: 'Uživatelské Jméno',
        mailAddress: 'E-mailová adresa',
        pwdFormat: 'Le mot de passe doit être de 6 à 18 caractères et doit contenir des chiffres, des lettres.',
        pwdConfirmFormat: 'Do obou polí nebylo zadáno stejné heslo.',
        pasConfirm: 'Potvrzení hesla',
        pleaseInput: 'Prosím, zadejte',
        name: 'Jméno',
        inputName: 'Prosím zadejte své jméno',
        userNameFormat: 'Uživatelské jméno může obsahovat pouze alfanumerické znaky nebo jednotlivé spojovníky a nemůže začínat ani končit spojovníkem.',
        password: 'Heslo',
        email: 'Boîte aux lettres',
        inputEmail: 'Zadejte prosím svou e-mailovou adresu',
        emailFormatError: 'Erreur de format de boîte aux lettres',
        enterEmail: 'Níže zadejte svůj e-mail a my vám zašleme pokyny k resetování.',
        selectCountry: 'Vybrat zemi',
        verificationCode: 'Verifikační kód',
        verificationFormat: 'Ověřovací kód je nesprávný.',
        CountryRegion: 'Země/Region',
        inputPwd: 'Zadejte prosím heslo',
        activationPrompt: 'Na Váš e-mail zašleme aktivační e-mail, který prosím aktivujte ve Vašem e-mailu před přihlášením.'
    },
    overview_module: {
        //overview
        today: 'Dnes',
        detectionQuantity: 'Detekční množství',
        abnormalQuantity: 'Abnormální množství',
        dailyDetection: 'Denní detekce',
        detectionItems: 'Detekce položek',
        bloodSugar: 'glykemie',
        bloodKetones: 'Krevní ketony',
        uricAcid: 'kyselina močová',
        lactate: 'Laktát',
        mailbox: 'poštovní schránka',
        detectionTime: 'Doba detekce',
        detectionValue: 'Hodnota detekce',
        unit: 'Jednotka',
        search: 'Vyhledávání',
        enterName: 'Napište jméno',
        gender: 'Rod',
        male: 'mužský',
        female: 'ženský',
        date: 'datum',
        //时段
        allGlucose: 'Všechna glukóza v krvi',
        midnight: 'Půlnoc',
        earlyMorning: 'Brzy ráno',
        afterBreakfas: 'Po snídani',
        beforeLunch: 'Před obědem',
        afterLunch: 'Po obědě',
        beforeDinner: 'Před večeří',
        afterDinner: 'Po večeři',
        bedtime: 'Před spaním'
    },
    table: {
        all: 'Všechno',
        display: 'Zobrazit',
        records: 'Evidence',
        unused: 'nepoužitý',
        used: 'použitý',
    },
    aside: {
        //侧边栏
        overview: 'Přehled',
        myPatients: 'Moji pacienti',
        personalInfo: 'Osobní informace',
        allPatients: 'Všichni pacienti',
        inviteCodes: 'Kód pozvánky',
        code: 'Kód',
        changePwd: 'Změnit heslo',
        allDoctors: 'Všichni lékaři',
        allAgent: 'Všichni agenti',
        allInviteCodes: 'Tous les codes d’invitation',
        operations: 'Operace',
        feedback: 'Zpětná vazba',
        software: 'Software'
    },
    footer: {
        service: 'Ochrana osobních údajů a smluvní podmínky',
        support: 'Podpora'
    },
    patient_module: {
        //patient
        remind: 'Připomenout',
        sendMsg: 'Poslat zprávu',
        DMType: 'Typ DM',
        lastUploadTime: 'Čas posledního nahrávání',
        device: 'Přístroj',
        lastMeasureTime: 'Čas poslední detekce',
        country: 'Země',
        type1: 'Typ I',
        type2: 'Typ II',
        otherForms: 'Jiné formy',
        GDM: 'Typ těhotenství',
        typePre: 'Před cukrovkou',
        typeSpecial: 'Speciální typ',
    },
    patient_detail_module: {
        confirmationTime: 'DM čas',
        addNote: 'Přidat poznámku',
        enterNote: 'Zadejte prosím informace o poznámkách',
        editNote: 'Poznámka redaktorů',
        confirmDeleteNote: 'Určitě smažete poznámku.',
        unbind: 'Odpojte se',
        table: 'Tabulka',
        logbook: 'Deník',
        trends: 'Trendy',
        period: 'Perioda',
        Days: 'Dny',
        other: 'Ostatní',
        AvgDailyRange: 'Průměrné denní hodnoty v rozsahu',
        AvgDailyNo: 'Průměrné denní čtení',
        readingRange: 'Hodnoty pod rozsahem',
        avgBG: 'Hodnoty nad rozsahem',
        DerivedFrom: 'Odvozený od',
        BGMReadings: 'Hodnoty BGM',
        weeks: 'Týdny',
        monday: 'Po',
        tuesday: 'Út',
        wednesday: 'St',
        thursday: 'Čt',
        friday: 'Pá',
        saturday: 'So',
        sunday: 'Ne',
        group: 'Skupina',
        range: 'Rozsah',
        avg: 'Průměrný',
        patientMGT: 'Management pacienta',
        medicine: 'Léky',
        food: 'Jídlo',
        sport: 'Sport',
        DMInfo: 'Informace o diabetu',
        height: 'Výška',
        weight: 'Hmotnost',
        PreMealSugarCtrlTgt: 'Cíl kontroly hladiny Glu před jídlem',
        PostprandialSugarCtrlTgt: 'Cíl kontroly hladiny Glu po jídle',
        info: 'informace',
        useDevice: 'Přístroj',
        associatedDoc: 'Přidružený lékař',
        associatedAgent: 'Přidružený agent',
        lastLoginTime: 'Čas posledního přihlášení',
        uploadMethod: 'Metoda nahrávání',
        addMethod: 'Jak jej přidat',
        manualAddition: 'Ruční přidávání',
        realTime: 'měření v reálném čase',
        historical: 'Historické měření',
        recordTime: 'Rekordní čas',
        dose: 'Dávka',
        type: 'Typ',
        calories: 'Kalorie',
        carbs: 'Sacharidy',
        proteins: 'Proteiny',
        fats: 'Tuky',
        strength: 'Síla',
        duration: 'Doba trvání',
        sendCustomerConfirm: 'Obsah zašleme přímo zákazníkovi, opakovaně jej prosím potvrďte.',
        selectExportedTime: 'Vyberte časový rozsah exportovaných dat',
        from: 'z',
        to: 'na',
        verificationCode: 'Verifikační kód',
        verificationFormat: 'Ověřovací kód je nesprávný.',
        DetectionStats: 'Statistiky detekce',
        addedToday: 'Přidáno dnes',
        addedWeek: 'Přidáno tento týden',
        addedMonth: 'Přidáno tento měsíc',
        remarksNoEmpty: 'Poznámky nemohou být prázdné',
        selectTableTime: 'Vyberte časové rozmezí dat tabulky',
        startDate: 'Date de début',
        endDate: 'Date de fin',
        belowRange: 'Lecture en dessous de la plage',
        inRange: 'Lecture dans la gamme',
        aboveRange: 'Lecture au - dessus de la plage'
    },
    weekdays: {
        Sun: 'Ne',
        Mon: 'Po',
        Tue: 'Út',
        Wed: 'St',
        Thu: 'Čt',
        Fri: 'Pá',
        Sat: 'So'
    },
    info_module: {
        basicInfo: 'Základní informace',
        avatar: 'Portrét hlavy',
        birthday: 'Narozeniny',
        chooseDate: 'Zvolte datum',
        selfIntro: 'Vlastní představení',
        PEIntro: 'Úvod do odborné praxe',
        oldPwd: 'Staré heslo',
        newPwd: 'Nové heslo',
        inputOldPwd: 'Zadejte prosím původní heslo',
        inputNewPwd: 'Zadejte prosím nové heslo',
        inputPwdAgain: 'Zadejte heslo znovu'
    },
    invite_module: {
        add: 'Přidejte',
        Use: 'Použití',
        pushMail: 'Vaše emailová schránka',
        remarks: 'Poznámky',
        creationTime: 'Čas vytvoření',
        action: 'Akce',
        generateCode: 'Vygenerujte kód pozvánky',
        codeInfo: 'Na e-mailovou adresu pošleme e-mail s aktivačním kódem. Připomeňte prosím pacientovi, aby jej zkontroloval.'
    },
    operation: {
        promot: 'Tipy',
        edit: 'Upravit',
        save: 'Uložit',
        yes: 'Potvrdit',
        delete: 'Smazat',
        saveSend: 'Uložit a odeslat',
        rePush: 'Zaslat znovu',
        cancel: 'Zrušit',
        exit: 'Déconnexion',
        confirmExit: 'Confirmer le retrait?',
        confirmDelete: 'Potvrdit smazání?',
        addSuccessed: 'Úspěšně přidáno!',
        editSuccessed: 'Úspěšně aktualizováno!',
        successfullyDelete: 'úspěšně smazat'
    }
}


// WEBPACK FOOTER //
// ./src/i18n/lang/cs.js